import { render, staticRenderFns } from "./NotificationsCard.vue?vue&type=template&id=3d50daf8"
import script from "./NotificationsCard.vue?vue&type=script&lang=js"
export * from "./NotificationsCard.vue?vue&type=script&lang=js"
import style0 from "./NotificationsCard.vue?vue&type=style&index=0&id=3d50daf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports